import React from 'react';

import {Box, Flex, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {useGlobalConfig} from '@amblique/king-living/app/contexts/global-config-context';

/**
 * Fallback skeleton for auth pages (login, reset-password).
 * Renders the same layout shell — background image panel + form panel — so the
 * transition from loadable() fallback → loaded page is seamless with no flash.
 */
const AuthPageFallback = () => {
  const styles = useMultiStyleConfig('PageAuth', {});
  const {loginImage, isReady} = useGlobalConfig();

  const hasImage = isReady && Boolean(
    loginImage?.mobileAsset?.url || loginImage?.tabletAsset?.url || loginImage?.desktopAsset?.url
  );

  const bgByBreakpoint = {
    base: loginImage?.mobileAsset?.url || loginImage?.tabletAsset?.url || loginImage?.desktopAsset?.url || undefined,
    md: loginImage?.tabletAsset?.url || loginImage?.desktopAsset?.url || loginImage?.mobileAsset?.url || undefined,
    lg: loginImage?.desktopAsset?.url || loginImage?.tabletAsset?.url || loginImage?.mobileAsset?.url || undefined,
  };

  return (
    <Box
      className={!hasImage ? 'no-image-background' : ''}
      {...styles.container}
    >
      <Flex
        className={!hasImage ? 'no-image-background' : ''}
        {...styles.content}
      >
        <Box
          className={!hasImage ? 'no-image-background' : ''}
          {...styles.backgroundImage}
          overflow="hidden"
          position="relative"
          sx={{
            ...styles.backgroundImage?.sx,
            ...(hasImage && {
              backgroundImage: {
                base: bgByBreakpoint.base ? `url(${bgByBreakpoint.base})` : 'none',
                md: bgByBreakpoint.md ? `url(${bgByBreakpoint.md})` : 'none',
                lg: bgByBreakpoint.lg ? `url(${bgByBreakpoint.lg})` : 'none',
              },
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }),
          }}
        />
        <Box {...styles.formContainer} />
      </Flex>
    </Box>
  );
};

AuthPageFallback.displayName = 'AuthPageFallback';

export default AuthPageFallback;
